import React from 'react';
import {
    withStyles,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Grid,
    Typography,
    Avatar,
    ButtonBase,
    Dialog, Zoom, Box,
    withRouter,
    ChevronRightOutlinedIcon
} from '../../material-ui';

import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import DeviceEventEmitter, { EventName } from '../../control/event';
import Apis from '../../network/Apis';
import AppConfig from '../../control/config';
import AppUtils from '../../control/apputlis';
import { OpenBrowser } from '../../control/ToName';
const showDialogBg = require("../../images/bg/bgdowndialog.png");
const jiantou = require("../../images/bg/jiantou_setting.png");
const ICON_offDialog = require("../../images/icons/closeDialog.png");



class SettingDialog extends React.Component {
    constructor(props) {
        super(props);
        this._onItemClick = this._onItemClick.bind(this);
        this._onUpdateAvatar = this._onUpdateAvatar.bind(this);
        this.state = {
            avatar: AppData.me.Pic,
            showDiaLog: false
        }
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.ON_UPLOAD_AVATAR, this._onUpdateAvatar, this);
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.ON_UPLOAD_AVATAR, this._onUpdateAvatar, this);
    }

    _onUpdateAvatar() {
        // window.history.back()
        this.setState({ avatar: AppData.me.Pic });
    }
    closeDialog = () => {
        this.setState({
            showDiaLog: false
        })
    }
    openDialog = () => {
        this.setState({
            showDiaLog: true
        })
    }
    downApp = () => {
        OpenBrowser(AppConfig.updatedUrl)
    }

    //显示弹窗
    dialogView = () => {
        return (
            <Dialog open={this.state.showDiaLog} classes={{}}>
                <Box sx={{ display: 'flex' }}>
                    <Zoom in={this.state.showDiaLog} style={{ transitionDelay: this.state.showDiaLog ? '0ms' : '0ms' }}>
                        <div className='dialogBox'>
                            {/* <img src={showDialogBg} style={{ width: '18rem' }} onClick={() => this.pushLogin()} /> */}
                            <div style={{ width: '18rem', position: 'relative' }} >
                                <img src={showDialogBg} style={{ width: '18rem' }} />
                                <img src={jiantou} onClick={() => this.downApp()} style={{ width: '60px', position: 'absolute', bottom: 38, left: '50%', marginLeft: '-30px' }} />

                            </div>

                            <img src={ICON_offDialog} style={{ width: 35, height: 35 }} onClick={() => this.closeDialog()} />
                        </div>
                    </Zoom>
                </Box>
            </Dialog>
        )
    }

    _showSelect() {
        if (!this.isWebClip()) {
            this.openDialog();
        }
        // window.handleHeadMdy((result) => {
        //     // result = result.replace("data:image/jpeg;base64,", '');
        //     this.updatePortrait(result);
        // });
    }

    isWebClip = () => {
        let { os } = this.props.match.params;
        let webclip = AppUtils.getQueryVariable('webclip');
        if (webclip && webclip == 1 || os == "ios" || AppUtils.isWebClip) {
            return true;
        }
        return false;
    }

    updatePortrait = async (file) => {
        let result = await Apis.encryptionUpdatePortrait(file, AppData.me.getUid());
        console.log('updatePortrait', result);
        if (result.code == 200) {
            this.setState({ Channels: result.data })
        }
    }

    _onItemClick(idx) {
        // this.openDialog();
        switch (idx) {
            case 0:
                this.props.history.push('/selfinfo')
                break;
            case 1:
                this.props.history.push('/safety')
                break;
            // case 2:
            //     this.props.history.push('/realname')
            //     break;
            default:
                break;
        }
    }

    render() {
        const { classes } = this.props;
        const { avatar } = this.state;
        return (
            <MBack title='个人信息' backgroundColor='#EFEFF4'>
                <Grid container justifyContent='center' className={classes.listTop}  >
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 13 }}>头像</Typography>} />
                    <Avatar onClick={() => this._showSelect()} className={classes.avatar} src={avatar} ></Avatar>
                </Grid>
                <ListItem className={classes.listCenter} button onClick={() => this._onItemClick(0)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>昵称</Typography>} />
                    <ListItemSecondaryAction style={{ right: 0 }}>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete" onClick={() => this._onItemClick(0)}>
                            <Typography style={{ color: '#878787', fontSize: 14 }}>{AppData.me.Username}</Typography>
                            <ChevronRightOutlinedIcon style={{ color: '#E2E2E2', fontSize: 20 }} />
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem className={classes.list1}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>账号</Typography>} />
                    <ListItemSecondaryAction>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete">
                            <Typography style={{ color: '#878787', fontSize: 14 }}>{AppData.me.PhoneNum}</Typography>
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid style={{ paddingLeft: 16, paddingRight: 16, backgroundColor: '#FFF' }}>
                    <div className={classes.divider1} />
                </Grid>
                <ListItem className={classes.list2}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>F7号</Typography>} />
                    <ListItemSecondaryAction>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete">
                            <Typography className={classes.listItta} style={{ color: '#878787', fontSize: 14 }}>{AppData.me.Uid}</Typography>
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem style={{ backgroundColor: '#fff', height: 50, borderRadius: 10, marginTop: 10 }} button onClick={() => this._onItemClick(2)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>个性签名</Typography>} />
                    <ListItemSecondaryAction style={{ right: 8 }}>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete" onClick={() => this._onItemClick(2)}>
                            <Typography style={{ color: '#878787', fontSize: 14 }}>没填写</Typography>
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <div >
                    {this.dialogView()}
                </div>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    icon: {
        color: '#E2E2E2',
        fontSize: 20,
    },
    avatar: {
        width: 60,
        height: 60,
        color: '#fff',
        backgroundSize: 'cover',
        marginRight: 16,
    },
    divider: {
        height: 8,
        padding: theme.spacing(0, 1.5, 0, 1.5),
        backgroundColor: '#F0F0F0',
    },
    divider1: {
        height: 1,
        padding: theme.spacing(0, 1.5, 0, 1.5),
        backgroundColor: '#F2F2F2',
    },
    listItta: {
        padding: theme.spacing(0, 1, 0, 0),
        textAlign: 'right',
    },
    listTop: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%',
        height: '30vw',
        backgroundColor: '#FFF',
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10
    },
    listCenter: {
        backgroundColor: '#fff',
        height: 50,
        borderRadius: 10,
        marginTop: 10,
    },
    list1: {
        backgroundColor: '#fff',
        height: 50,
        marginTop: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10
    },
    list2: {
        backgroundColor: '#fff',
        height: 50,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10
    },
}))(SettingDialog));